<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="form-container">
    <div class="header-cont">
      <CircularButton
        class="back-btn"
        icon="long-arrow-alt-left"
        color="#0000"
        @click="goBack()"
      />
      <h2>Add Your Business</h2>
      <Paw />
      <p class="page-moto">
        <span class="normal-text"
          >Our mission is an energized and vivid community of people, with
          common goal to improve the quality of pets’ and pets owners’ life and
          we couldn’t do it without you!</span
        >
      </p>
      <p class="page-moto">
        <span class="pop-text"
          >Now you can add your pet-friendly business ΗΕRE!</span
        >
      </p>
    </div>
    <div class="bus-logo">
      <img :src="image" alt="Profile Image" style="width: 100%" />
      <div class="photo-uploader">
        <label for="bus-logo-uploader">
          <fa id="upload-icon" icon="upload" />
        </label>
        <input type="file" id="bus-logo-uploader" @change="handleFileUpload" />
      </div>
    </div>
    <p style="margin-block: 1em 0">Business Logo</p>
    <form @submit.prevent="createBusiness">
      <div class="input-field">
        <label for="type"><fa class="icon" icon="info" /> Business Type</label>
        <select name="type" v-model="formData.type">
          <option value="" selected disabled>
            Select
            {{
              formData.name == "" || formData.name == null
                ? "Business"
                : `${formData.name}'s`
            }}
            Type
          </option>
          <!-- <option value="Pet_sitter_/_Dog_walker">
            Pet sitter / Dog walker
          </option>
          <option value="Veterinarian">Veterinarian</option>
          <option value="Pet_store">Pet store</option>
          <option value="Pet_hotel">Pet hotel</option>
          <option value="Pet_trainer">Pet trainer</option>
          <option value="Pet_groomer">Pet groomer</option>
          <option value="Animal_shelter">Animal shelter</option>
          <option value="Other_pet_service">Other pet service</option> -->
          <option value="Doctors">Doctors</option>
          <option value="Pet_supplies">Pet supplies</option>
          <option value="Groomers">Groomers</option>
          <option value="Trainers">Trainers</option>
          <option value="Nannies">Nannies</option>
          <option value="Hotels">Hotels</option>
          <option value="Walkers">Walkers</option>
          <option value="Shelters">Shelters</option>
          <option value="Other_Services">Other Services</option>
        </select>
      </div>
      <div class="input-field">
        <label for="name"><fa class="icon" icon="info" /> Name</label>
        <input
          required
          type="text"
          placeholder="Name"
          name="name"
          v-model="formData.name"
        />
      </div>

      <div class="input-field">
        <label for="tel"><fa class="icon" icon="phone" /> Telephone</label>
        <input
          required
          type="tel"
          placeholder="Telephone"
          name="tel"
          v-model="formData.tel"
        />
      </div>
      <div class="input-field">
        <label for="email"><fa class="icon" icon="at" /> Email</label>
        <input
          required
          type="email"
          placeholder="Email"
          name="email"
          v-model="formData.email"
        />
      </div>
      <div class="input-field">
        <label for="website"><fa class="icon" icon="globe" /> Website</label>
        <input
          type="text"
          placeholder="Website"
          name="website"
          v-model="formData.website"
        />
      </div>
      <div class="input-field time-selector">
        <label for="type"
          ><fa class="icon" icon="clock" /> Business Schedule</label
        >
        <div class="selects">
          <select name="type" v-model="formData.scheduleOpen">
            <option value="" selected disabled>Open</option>
            <option
              v-for="index in 24"
              :key="index - 1"
              :value="index - 1 + ':00'"
            >
              {{ index - 1 + ":00" }}
            </option>
          </select>
          <select name="type" v-model="formData.scheduleClose">
            <option value="" selected disabled>Close</option>
            <option
              v-for="index in 24"
              :key="index - 1"
              :value="index - 1 + ':00'"
            >
              {{ index - 1 + ":00" }}
            </option>
          </select>
        </div>
      </div>
      <div class="input-field custom-textarea-container">
        <label
          for="description"
          :style="
            formData.description != ''
              ? formData.description.length > 250
                ? 'color: var(--danger);'
                : ''
              : null
          "
          ><fa class="icon" icon="info" /> Description ({{
            formData.description !== null && formData.description !== ""
              ? formData.description.length
              : "0"
          }}/250 char.)</label
        >
        <textarea
          type="text"
          class="custom-textarea"
          placeholder="Description"
          name="description"
          v-model="formData.description"
          data-role="none"
        />
      </div>
      <Button text="Submit" color="var(--primary-clr)" />
    </form>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";
import Paw from "@/components/stylistics/Paw.vue";

let allowedFileExtensions = ["jpg", "png", "jpeg"];
let jwt;

let headers = {};

function submitImage(self) {
  let formData = new FormData();
  formData.append("file", self.imageFile);
  // console.log(formData);
  // let self = self;

  let jwt = localStorage.getItem("jwt");
  if (jwt == null) {
    Swal.fire("An error occured!", "Please refresh the page.", "error").then(
      (res) => {
        if (res.isConfirmed) {
          self.$router.push("/");
        }
      }
    );
  }

  axios
    .post(
      `${process.env.VUE_APP_BACKEND}/business/${self.businessID}/image/upload`,
      formData,
      {
        headers: headers,
      }
    )
    .then(() => {
      Swal.fire(
        "Success",
        `${self.formData.name} has been added to your businesses.`,
        "success"
      ).then(() => {
        self.$router.push("/profile");
      });
    })
    .catch(() => {
      Swal.fire(
        "An error occured",
        `${self.formData.name} has been added to your businesses, but the image you provided was not uploaded. Please try again later.`,
        "error"
      ).then(() => {
        self.$router.push("/profile");
      });
    });
}

export default {
  components: { Navbar, Button, CircularButton, LoadingScreen, Paw },
  name: "AddBusiness",
  data() {
    return {
      imageFile: "",
      formData: {
        name: "",
        type: "",
        description: "",
        website: "",
        tel: "",
        email: "",
        scheduleOpen: "",
        scheduleClose: "",
      },
      businessID: "",
      image: "/paw.svg",
    };
  },
  methods: {
    handleFileUpload(event) {
      let self = this;

      // VALIDATE THE FILE
      let splitFilename = event.target.files[0].name.split(".");
      let fileExtension = splitFilename[splitFilename.length - 1];
      // console.log(fileExtension);
      // IF THE FILE IS OF AN UNSUPPORTED TYPE, RETURN WHILE THROWING AN ERROR
      if (!allowedFileExtensions.includes(fileExtension)) {
        Swal.fire(
          "Error",
          "The file you uploaded is not supported. Try uploading a file with a valid extension. <br/><b>Valid extensions:</b> " +
            allowedFileExtensions,
          "error"
        );
        return;
      }

      self.imageFile = event.target.files[0];
      Swal.fire({
        title: "Upload Image?",
        html: "You have uploaded a file: <b>" + self.imageFile.name + "</b>",
        icon: "question",
        showCancelButton: true,
        // cancelButtonColor: "#CC2200",
        confirmButtonText: "Upload",
      }).then((res) => {
        if (res.isConfirmed) {
          // self.image = this.submitImage();
          // console.log(self.imageFile);
          self.image = URL.createObjectURL(self.imageFile);
        }
      });
    },
    createBusiness() {
      if (this.formData.description.length <= 250) {
        if (
          this.formData.name != "" &&
          this.formData.type != "" &&
          this.formData.email != "" &&
          this.formData.tel != "" &&
          this.formData.website != ""
        ) {
          let data = {};
          data.contact = {};

          data.name = this.formData.name;
          data.type = this.formData.type;
          data.desc = this.formData.description;

          data.contact.email = this.formData.email;
          data.contact.website = this.formData.website;
          data.contact.tel = this.formData.tel;
          data.contact.schedule = `${this.formData.scheduleOpen}-${this.formData.scheduleClose}`;

          headers["content-type"] = "application/json";
          // // console.log(headers);
          let _self = this;
          axios
            .post(`${process.env.VUE_APP_BACKEND}/business/`, data, {
              headers: headers,
            })
            .then(function (res) {
              // console.log(res);
              _self.businessID = res.data._id;
              // console.log("Line 316: ", _self.businessID);
              if (_self.image != "/paw.svg" && _self.image) {
                submitImage(_self);
              } else {
                Swal.fire(
                  "Success",
                  `${_self.formData.name} has been added to your businesses. You can upload an image anytime by editing ${_self.formData.name} from your profile page.`,
                  "success"
                ).then(() => {
                  _self.$router.push("/profile");
                });
              }
              // console.log(res);
            })
            .catch(function (err) {
              // console.log(err);
              Swal.fire("Error", "" + err, "error").then(() => {
                _self.$router.push("/profile");
              });
            });
          // console.log("Info Updated.");
        } else {
          // console.log("Same data!");
          Swal.fire("Error", "Some information are missing!", "error");
        }
      } else {
        Swal.fire(
          "Warning",
          "The description must be 50 words or less!",
          "warning"
        );
      }
    },
    goBack() {
      let self = this;
      self.$router.go(-1);
    },
  },
  mounted() {
    let title = "Add Your Business - Dating4Pets";
    document.title = title;

    let self = this;
    jwt = localStorage.getItem("jwt");
    if (jwt == null) {
      self.$router.push("/");
    }

    headers = {
      Authorization: "Bearer " + jwt,
      // "content-type": "multipart/form-data",
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
        headers: headers,
      })
      .then(function () {
        // console.log("Henlo");
        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Swal.fire("Error", `${err}`, "error");
        }
      });
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: initial;
  color: var(--dark-clr);
  width: 90%;
  max-width: 50rem;
  height: 80%;
  margin-block-start: 3.5rem;
  padding: 2rem;
  position: relative;
  background: white;
  box-shadow: 0 0.1rem 1rem 0.2rem rgba(126, 126, 126, 0.3);
  border-radius: 1rem;
  margin: auto;
  margin-block-start: 7em;
}

form {
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  justify-content: center;
  align-items: center;

  padding-block: 2em;
  /* padding-inline: 1.5em; */
  gap: var(--gap);
  z-index: 100;
  width: 100%;
  overflow: visible;
}

#form-logo {
  width: 50%;
  aspect-ratio: 1;
}

p {
  color: var(--dark-clr);
}
a {
  text-decoration: none;
}
h2 {
  margin-block: 1em;
}
.form-link {
  color: var(--primary-clr);
  transition: 0.5s ease;
}
.form-link:hover,
.form-link:focus {
  color: var(--dark-clr);
}

.input-field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: visible;
  /* width: 60%; */
  /* width: 80%; */
  width: 70%;
  position: relative;
}

.input-field > input,
select,
.input-field > .custom-textarea {
  height: 2rem;
  min-width: 15em;
  width: 70%;
  max-width: 20em;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  /* margin-inline-start: auto; */
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
}

select {
  cursor: pointer;
}

.input-field > input::placeholder {
  color: var(--mid-dark-clr);
}

.input-field > input:focus,
.input-field > .custom-textarea-container {
  border: none;
  box-shadow: var(--box-shadow-focus);
}

.input-field > label {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: var(--gap);
  text-align: left;
}

.input-field > label .icon {
  /* color: var(--icon-color); */
  color: var(--primary-clr);
  /* margin: 0 0.5rem; */
  width: 16px;
  height: 16px;
}

.custom-textarea-container {
  flex-direction: column;
  align-items: flex-start;
  gap: var(--gap);
}

.custom-textarea-container .custom-textarea {
  min-width: none;
  width: 100%;
  max-width: 100%;
  height: 3rem;
  /* background: red; */
  overflow-y: scroll;
  resize: none;
  /* border-radius: 2em 0 0 2em; */
  overflow-x: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.custom-textarea-container .custom-textarea::-webkit-scrollbar {
  display: none;
}

.input-field > label {
  min-width: 4em;
  width: 100%;
  max-width: 10em;
}

.input-field > input:disabled {
  background: rgb(220, 220, 220);
  box-shadow: none;
}

.message {
  position: absolute;
  right: 0;
  top: -80%;
  /* background: black; */
  /* color: white; */
  height: 2em;
  padding-inline: 0.5em;
  border-radius: 15em;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--light-box-shadow);
  opacity: 0;
  transition: var(--transition);
}
.input-field label {
  overflow: visible;
}

input:disabled:hover + .message {
  opacity: 1;
}

.bus-logo {
  background: #0000;
  border-radius: 50%;
  min-width: 10em;
  width: 10%;
  max-width: 30em;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: 15%;
  z-index: 1000;
  box-shadow: var(--light-box-shadow);
}

input[type="file"] {
  /* display: none; */
  display: block;
  width: 100%;
  opacity: 0;
  position: absolute;
  height: 100%;
  cursor: pointer;
}

.bus-logo:hover .photo-uploader,
.bus-logo:focus .photo-uploader,
.photo-uploader:hover,
.photo-uploader:focus {
  /* display: flex; */
  opacity: 1;
}

.photo-uploader:hover,
.photo-uploader:focus {
  opacity: 1;
}

.bus-logo:hover {
  box-shadow: var(--box-shadow-focus);
}

#upload-icon {
  width: 30%;
  height: 30%;
  color: var(--light-clr);
  /* margin: auto; */
}

.back-btn {
  position: absolute;
  left: calc(0% + 2em);
  top: calc(0% + 3em);
  animation-name: playfullCallToAction;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transition: var(--transition);
}

.header-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page-moto {
  margin-block: 1em 0em;
}

.page-moto:last-child {
  padding-block: 1em 2em;
}

.page-moto .normal-text {
  width: 100%;
}

.page-moto .pop-text {
  width: 100%;
  font-weight: bold;
}

.selects {
  min-width: 15em;
  width: 70%;
  max-width: 20em;
  display: flex;
  overflow: visible;
  align-items: center;
  justify-content: flex-end;
}

.input-field.time-selector .selects select {
  min-width: 1em;
  width: 40%;
  /* max-width: none; */
}

@media screen and (max-width: 30rem) {
  .form-container {
    margin: 1rem;
  }
  .back-btn {
    position: relative;
    left: 0;
    top: 0;
  }
}

@media screen and (max-width: 35rem) {
  .input-field {
    flex-direction: column;
    justify-content: center;
  }
  .input-field label {
    margin-block: 1em 0.5em;
    /* width: 75%;
    justify-content: space-between; */
    align-self: flex-start;
  }
  .input-field.custom-textarea-container {
    align-items: center;
  }
  .selects {
    align-items: flex-start;
    justify-content: center;
  }
}

@media screen and (max-width: 54rem) {
  /* .input-field {
    justify-content: center;
  } */
  .del-account-cont {
    width: 100%;
  }
  .back-btn {
    margin-block-start: 3em;
  }
  .input-field > label {
    font-size: 0.8rem;
  }
}
</style>
